const PROJECT_TYPE_LABELS = new Map<string, string>([
  ['unknown', 'Unknown'],
  ['unsupported', 'Unsupported'],
  ['dbt', 'dbt'],
  ['rudderstack-profiles', 'Profiles'],
  ['cube', 'Cube'],
  ['sqlmesh', 'SQLMesh'],
  ['lookml', 'LookML'],
  ['rudder-cli', 'Rudder CLI'],
  ['rudderstack-sdk', 'RudderStack SDK'],
]);

export function projectTypeLabel(type: string): string {
  return PROJECT_TYPE_LABELS.get(type) ?? type;
}
